import React  from "react";
import ReactModal from "react-modal";
import { Input, Select, Radio  } from "@components/form";
import { Draggable, Pagination} from "@components";
import { FormProvider } from "react-hook-form";
import { useLectureStdtModal } from "@hooks";

function LectureStdtModal({ isOpen, onClose, lectureId, onSuccess }) {

  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  const containerStyle = {
    maxWidth: "1300px",
    minWidth: "1300px",
    maxHeight: "730px",
    minHeight: "730px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  const {
    methods, data, onSubmit, isAllChecked, selectedItems,
    handlePageChange, handleSelectAll, handleSelectItem, addStudent,
    pageIndex, recordCountPerPage,
    refetch, resetSelection, resetSearch
  } = useLectureStdtModal(lectureId);

  const curCnt = data?.lectureInfo.curStudentCnt; // 현재 수강 인원 수
  const limitCnt = data?.lectureInfo.eduStdntLimit; // 제한 인원 수
  const remain = Math.max(limitCnt - curCnt, 0); // 남은 수강 인원 수
  const willExceed = selectedItems.length > remain // 초과 인원 수
  const isMultiDay = Boolean(data?.lectureInfo.lastDt);

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        alert("수강생을 한 명 이상 선택하세요.");
        return;
    }
    if (willExceed) {
        alert(`정원 초과입니다. 남은 자리: ${remain}명`);
        return;
    }

    try {
        const eduDtCd = isMultiDay ? (methods.getValues('eduDtCd') || 'A') : 'F';

        const response = await addStudent(eduDtCd);

        await refetch();
        resetSelection();

        onSuccess(response);
      } catch (err) {
        console.error(err);
        alert("수강생 추가에 실패했습니다.");
      }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      className="modal-wrap"
    >
      <div className="modal-container" style={containerStyle}>
          <div className="modal-header"  style={{ cursor: "move" }}>
            <h5>수강생 추가</h5>
            <button type="button" className="modal-btn-close" onClick={onClose}>
              <span className="modal-btn-span">X</span>
            </button>
          </div>
        <FormProvider {...methods}>  
        <div className="modal-content">
          <div className="search-wrap">
            <div className="search-row">
              <div className="search-item">
                <Select
                  name="searchCnd"
                  options={[
                    { key: "0", name: "아이디" },
                    { key: "1", name: "이름" },
                    { key: "2", name: "소속회사" },
                  ]}
                  defaultOption="선택"
                  className="input-select"
                />
                <Input
                  name="searchWrd"
                  placeholder="검색어를 입력하세요"
                  className="input-search"
                  style={{ width: "250px" }}
                />
              </div>
              <div className="search-btn-container">
                <button type="button" className="btn-search" onClick={methods.handleSubmit(onSubmit)} >조회</button>
                <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
              </div>
            </div>
          </div>
          {isMultiDay && (
            <div style={{ display: "flex", gap: "15px", margin: "10px" }}>
                <label>
                <span className="icon-bars" />
                <strong>수강 일수</strong>
                </label>

                <Radio name="eduDtCd" label="이틀"   value="A" defaultChecked/>
                <Radio name="eduDtCd" label="첫째날" value="F"  />
                <Radio name="eduDtCd" label="둘째날" value="S" />

            </div>
           )}
           <div className="section-tit-wrap" style={{display:"flex", justifyContent:"space-between"}}>
                <h3 className="border-left-primary">
                    <span className="total-txt">&nbsp;정원&nbsp;
                        <span className={curCnt > limitCnt ? "red" : ""}>{curCnt}/{limitCnt}</span>
                        <span className="red">{remain === 0 && " (정원 마감)"}</span>
                        <span className="red">{willExceed && " (정원 초과)"}</span>
                    </span>
                </h3>
                <div className="btn-right-box">
                    <ul>
                        <li><button type="button" className="btn-save" onClick={handleConfirm} disabled={selectedItems.length === 0 || willExceed || remain === 0}>추가</button></li>
                    </ul>
                </div>
            </div>
            <div className="table-container">
            <table className="table-list" style={{ width: "100%" }}>
              <colgroup>
                <col style={{ width: "3%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th><input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} /></th>
                  <th>아이디</th>
                  <th>이름</th>
                  <th>생년월일</th>
                  <th>이메일</th>
                  <th>소속회사</th>
                </tr>
              </thead>
              <tbody>
              {data?.resultList && data.resultList.length > 0 ? (
                    data.resultList.map((item) => {
                      return (
                        <tr
                            key={item.memberId}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSelectItem(item.memberId)
                            }}
                        >
                          <td>
                          <input 
                              type="checkbox" 
                              checked={selectedItems.includes(item.memberId)} 
                              onChange={(e) => {
                                e.stopPropagation();
                                handleSelectItem(item.memberId)
                              }} />
                          </td>
                          <td>{item.memberId}</td>
                          <td>{item.memberNm}</td>
                          <td>{item.birthDt}</td>
                          <td>{item.email}</td>
                          <td>{item.companyNm}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center" }}>
                        조회 결과가 없습니다.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>

          </div>
          {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                <Pagination
                    totalPages={Math.ceil(
                    data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                    )}
                    currentPage={pageIndex}
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={recordCountPerPage}
                />
              )}
        </div>

        </FormProvider>
        <div className="modal-btn-wrap btn-right-box">
            <ul>
                <li><button type="button" className="btn-cancel" onClick={onClose}>닫기</button></li>
                
            </ul>
        </div>
      </div>
    </ReactModal>
  );
}

export {LectureStdtModal};
